import { FormChange } from "./form";

export interface Button {
  title?: string;
  label?: string;
  classStyle?: string;
  type?: number;
  onClick?: (args?: any) => void;
  isCancel?: boolean;
}

export enum ButtonTypes {
  Confirm = 1,
  Cancel = 2,
}

export enum ModalTypes {
  Alert = "alert",
  Confirmation = "confirmation",
  FormChanges = "form-changes",
}

export interface ModalOptions {
  title?: string;
  titleClassList?: string[];
  description?: string;
  html?: string;
  loading?: boolean;
  buttons?: Button[];
  buttonsPosition?: string;
  allowClose?: boolean;
  changes?: FormChange[];
  fullscreen?: boolean;
  active?: boolean;
  centerButtons?: boolean;
  allowBackgroundScroll?: boolean;
  textAlign?: string;
	type?: number;
}

export interface ModalStyleOptions {
  modalContainer?: {
    classes?: string[];
    width?: string;
    maxWidth?: string;
    margin?: string;
    backgroundColor?: string;
    borderRadius?: string;
  };
  modalHeader?: {
    classes?: string[];
    width?: string;
    borderBottom?: string;
    padding?: string;
    borderTopLeftRadius?: string;
    borderTopRightRadius?: string;
    display?: string;
    justifyContent?: string;
  };
  modalTitle?: {
    classes?: string[];
  };
  modalBody?: { classes?: string[]; minHeight?: string; padding?: string };
  modalFooter?: {
    classes?: string[];
  };
}

export interface DialogueModal {
  title?: string;
  description?: string;
  buttons: Button[];
  loading?: boolean;
  closeBtn?: boolean;
}
